export const PRICE_CURRENT = "AR$ 21.990";
export const PRICE_OLD = "AR$ 39.990";
export const SAVINGS = "45%";

export interface Testimonial {
  name: string;
  province: string;
  avatar: string;
  text: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "María",
    province: "Córdoba",
    avatar:
      "https://cdn.magicpatterns.com/patterns/generated-images/a31a274f-b869-4e32-a758-b097eb7742f4.jpg",
    text: "Lo que más cambió fue nuestra mañana antes de ir a la escuela. Antes era una batalla; ahora tenemos una rutina que los dos entendemos. Bajó muchísimo el estrés en casa.",
  },
  {
    name: "Diego",
    province: "Mendoza",
    avatar:
      "https://cdn.magicpatterns.com/patterns/generated-images/cab70a60-8917-45e5-9314-956cae054f36.jpg",
    text: "Dejé de improvisar. Cuando aparece una crisis, sé a qué tomo ir y qué hacer. Por primera vez siento que estoy acompañando y no solo reaccionando.",
  },
  {
    name: "Laura",
    province: "Rosario",
    avatar:
      "https://cdn.magicpatterns.com/patterns/generated-images/d767478c-8ed7-4489-b05b-e1fd1c79b302.jpg",
    text: "Tenía guardados decenas de videos y consejos sueltos. Acá está todo ordenado y con sentido. Es como tener una guía al lado en los momentos difíciles.",
  },
  {
    name: "Silvia",
    province: "La Plata",
    avatar:
      "https://cdn.magicpatterns.com/patterns/generated-images/aefa1321-2f31-45c6-abf1-07fba94eb1e9.jpg",
    text: "La escuela me pedía estrategias y yo no sabía qué responder. Ahora llevo herramientas concretas y me siento parte del equipo que acompaña a mi hijo.",
  },
];

export const activityPopups: string[] = [
  "María de Córdoba acaba de acceder.",
  "Laura de Rosario compró hace 3 minutos.",
  "Camila de Mendoza eligió el Pack Completo.",
  "Diego de La Plata acaba de acceder.",
  "Sofía de Salta compró hace 6 minutos.",
  "Valentina de Neuquén eligió el Pack Completo.",
];

export const trustBadges = [
  { icon: "lock", label: "Pago seguro con Mercado Pago" },
  { icon: "zap", label: "Acceso inmediato después de la compra" },
  { icon: "shield", label: "Garantía de 7 días" },
  { icon: "devices", label: "Compatible con celular, tablet y PC" },
];

export const tomos = [
  {
    n: 1,
    title: "Comprender sin Culpas",
    desc: "Entendé qué es realmente el TDAH y el Autismo, derribá mitos y comprendé por qué tu hijo actúa como actúa.",
    img: "https://cdn.magicpatterns.com/patterns/generated-images/290fbdfe-5600-4231-a746-e29f0f647f6d.jpg",
  },
  {
    n: 2,
    title: "Rutinas que Dan Calma",
    desc: "Aprendé a construir rutinas simples que reduzcan el estrés y aporten mayor previsibilidad al día.",
    img: "https://cdn.magicpatterns.com/patterns/generated-images/1deb8c03-5c81-491b-a22f-5d03774f0aad.jpg",
  },
  {
    n: 3,
    title: "Atención, Impulsividad y Aprendizaje",
    desc: "Descubrí estrategias para mejorar el foco, acompañar la impulsividad y facilitar el aprendizaje cotidiano.",
    img: "https://cdn.magicpatterns.com/patterns/generated-images/9addaa54-a07c-41c3-8b2c-9795443919d1.jpg",
  },
  {
    n: 4,
    title: "Emociones, Crisis y Autorregulación",
    desc: "Aprendé a identificar desencadenantes, acompañar emociones intensas y actuar durante una crisis con mayor seguridad.",
    img: "https://cdn.magicpatterns.com/patterns/generated-images/b8bf037e-ba0f-4b7f-9f20-6e2ba190259d.jpg",
  },
  {
    n: 5,
    title: "Comunicación, Juego y Vínculo",
    desc: "Fortalecé el vínculo con actividades, comunicación positiva y estrategias que favorecen el desarrollo.",
    img: "https://cdn.magicpatterns.com/patterns/generated-images/1568c228-8f31-485b-92e8-8f91a6ff17a0.jpg",
  },
  {
    n: 6,
    title: "El Adulto que Acompaña",
    desc: "Porque para ayudar a un niño también necesitás cuidar al adulto que está sosteniendo todo.",
    img: "https://cdn.magicpatterns.com/patterns/generated-images/2dbc2745-d26c-4e62-90fe-e08d9e207e74.jpg",
  },
];

export interface Preview {
  src: string;
  label: string;
}

/** Real pages from the product. The final three uploads lead the carousel. */
export const previews: Preview[] = [
  {
    src: "https://cdn.magicpatterns.com/uploads/iy5em7H2scEhWDzZsTZth9/Captura_de_pantalla_2026-07-18_a_la(s)_12.33.56_a._m..png",
    label: "Estrategias que empiezan por comprender",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/2y6LQA7HSXJaZ58FHsucfR/Captura_de_pantalla_2026-07-18_a_la(s)_12.34.13_a._m..png",
    label: "Herramientas claras para mirar sin culpas",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/jw5wybgQrQjgNeB9U4Q2YN/Captura_de_pantalla_2026-07-18_a_la(s)_12.34.29_a._m..png",
    label: "Un plan con pasos reales para cada día",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/6xXNxZpcLQgGLMA99cJ4Xx/Captura_de_pantalla_2026-07-18_a_la(s)_12.31.06_a._m..png",
    label: "Cómo puede verse el TDAH en la vida diaria",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/dVsdYeMcpAtV8S2mSG35uK/Captura_de_pantalla_2026-07-18_a_la(s)_12.31.56_a._m..png",
    label: "Primeros pasos para acompañar mejor",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/5dCJb5Cumy3aVzmsyyh3MJ/Captura_de_pantalla_2026-07-18_a_la(s)_12.32.26_a._m..png",
    label: "Todo lo que encontrás en cada volumen",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/3BXHBtGyVmVu1CZEpxiXMf/Captura_de_pantalla_2026-07-18_a_la(s)_12.32.45_a._m..png",
    label: "Cómo funciona el cerebro en una crisis",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/k6kArH96UKQw7MjBUyDWuW/Captura_de_pantalla_2026-07-18_a_la(s)_12.33.06_a._m..png",
    label: "La conexión va antes que la corrección",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/nY1x7XKEK7VNvetywaqsGT/Captura_de_pantalla_2026-07-18_a_la(s)_12.33.21_a._m..png",
    label: "Cómo procesa la información un niño",
  },
  {
    src: "https://cdn.magicpatterns.com/uploads/w6LuFEp6Hwjaf9JLYUfQSn/Captura_de_pantalla_2026-07-18_a_la(s)_12.33.38_a._m..png",
    label: "Errores de comunicación que podés evitar",
  },
];

export const heroMockup =
  "https://cdn.magicpatterns.com/uploads/6cTJiA9A1M4H3KimKpdKzX/ChatGPT_Image_4_jul_2026,_01_07_31.png";
